// extracted by mini-css-extract-plugin
export default {"tab-drag-n-drop":"DragAndDropFileUpload_tab-drag-n-drop__Achf1"};